'use client';
import parse from 'html-react-parser';
import { Button } from '@overlapdev/elements';
import Image from 'next/image';
import Link from 'next/link';
import { PageType } from '@overlapdev/types';
import { CircleArrowSVG, RestoreLogoSVG } from 'components/svg';

const LocationMapPopup = ({ item }: { item: PageType }) => {
	//__Variables
	const { acf, post_title, relative_path } = item || {};
	const { alternate_detail_page, grid_image, address, phone_number, alternate_address_link } = acf || {};

	const detail_page = alternate_detail_page?.url ? alternate_detail_page.url : relative_path;

	//__Functions

	//__Use Effect

	return (
		<div className='flex flex-col group overflow-hidden relative rounded-3xl transition-ease shadow-[30px_35px_55px_0px_rgba(46,46,46,0.23)] w-[250px] lg:w-[320px]'>
			<div className='overflow-hidden relative h-[120px] md:h-[180px]'>
				{grid_image?.url ? (
					<Image src={grid_image.url} alt={grid_image.alt} fill className='object-cover object-[50%_50%] transition-ease md:group-hover:scale-110' sizes='960px' />
				) : (
					<div className='bg-black/10 flex h-full items-center justify-center p-4 lg:p-10'>
						<RestoreLogoSVG className='opacity-60' fill='#fff' />
					</div>
				)}
			</div>
			<div className='bg-white flex flex-col font-display gap-1 grow items-start px-6 py-3 rounded-b-3xl text-sm'>
				<div className='font-semibold text-black text-lg'>{parse(post_title)}</div>
				{address ? (
					<div>
						<div>Address</div>
						<Link href={alternate_address_link || `https://maps.google.com/?q=${`${address.street_number} ${address.street_name_short ? address.street_name_short : address.street_name}, ${address.city}, ${address.state_short ? address.state_short : address.state} ${address.post_code}`}`} target='_blank' className='font-semibold text-dark-blue'>
							{address.street_number} {address.street_name_short ? address.street_name_short : address.street_name}, {address.city}, {address.state_short ? address.state_short : address.state} {address.post_code}
						</Link>
					</div>
				) : null}
				{phone_number ? (
					<div>
						<div>Phone Number</div>
						<a href={`tel:${phone_number}`} className='font-semibold text-dark-blue'>
							{phone_number}
						</a>
					</div>
				) : null}
				<div className=''>
					<Button link={{ url: detail_page, title: 'See Details', target: alternate_detail_page?.url || '_self' }} className='arrow_link !text-sm'>
						<CircleArrowSVG width={18} />
					</Button>
				</div>
			</div>
		</div>
	);
};

export default LocationMapPopup;
